var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isLoading || _vm.tireaUrl)?_c('a',{attrs:{"href":_vm.tireaUrl,"target":"_blank"}},[_c('v-btn',{attrs:{"color":"primary","outlined":"","loading":_vm.isLoading,"disabled":_vm.isLoading,"depressed":""}},[_vm._v(_vm._s(_vm.$t('tirea.access')))])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }